import { normalizeToUTC } from "@revbox/helpers-fe";
import axiosInstance from "../../axios/instance";
import { getToken } from "../../helpers/get-token";
async function getInventoriesClicksDistribution(currentPeriod, inventoryId) {
    try {
        const token = getToken();
        axiosInstance.defaults.headers.common['authorization'] = token;
        const response = await axiosInstance.post(process.env.REACT_APP_HUB_URL + '/api/missed-clicks/inventories-clicks-distribution', {
            current_period: [
                normalizeToUTC(currentPeriod[0]).getTime(),
                normalizeToUTC(currentPeriod[1]).getTime()
            ],
            inventory_id: inventoryId
        })
        return response?.data;
    } catch (error) {
        console.log(error);
    }
}

export default getInventoriesClicksDistribution;
